/** Spec limits of the support request (Technical Support Specification, section 2). */
export const DESCRIPTION_MAX = 5000;
export const TIME_PERIOD_MAX = 200;
/** The time-period counter appears once the text gets this long. */
export const TIME_PERIOD_COUNTER_FROM = 180;
/** The description counter announces "N characters left" from this many left. */
export const DESCRIPTION_NEAR_LIMIT = 500;

/**
 * Attachments: up to 10 MB in total, no limit on the file count. Decimal megabytes
 * (1 MB = 1,000,000 bytes), the same unit the file cards display, so the limit and
 * the shown sizes never disagree.
 */
export const ATTACHMENTS_MAX_TOTAL_BYTES = 10_000_000;

export const SUPPORT_EMAIL = 'support@investbanq.com';

/** Mock-service scenario markers, put in the description (see mock-support.service). */
export const MOCK_MARKERS = {
  rateLimit: '[mock:429]',
  serverError: '[mock:500]',
  filesRejected: '[mock:422]',
} as const;
